// extracted by mini-css-extract-plugin
export default {"container":"StatsRowSingleColumn_container__+yqMw","count":"StatsRowSingleColumn_count__EhZRL","right":"StatsRowSingleColumn_right__JVXSP"};